import React from 'react';
import { Timer } from './Timer';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-brand-deepInk border-t border-white/5 pt-[8px] pb-[8px] relative overflow-hidden" data-id="element-104">
      {/* Background glows */}
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[300px] h-[100px] bg-brand-gold/15 blur-3xl rounded-full pointer-events-none" data-id="element-105"></div>
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-brand-purple/20 blur-[120px] rounded-full pointer-events-none" data-id="element-106"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-107">
        <div className="mb-10" data-id="element-108">
          <h2 className="text-4xl font-black text-white mb-4 relative inline-block" data-id="element-109">
            ÚLTIMA OPORTUNIDAD
          </h2>
        </div>

        <Timer data-id="element-110" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12 mb-12 relative z-10" data-id="element-111">
          <div className="relative w-full" data-id="element-112">
            <div className="absolute -inset-2 bg-brand-purple/30 blur-2xl rounded-2xl -z-10 pointer-events-none" data-id="element-113"></div>
            <motion.a href="https://www.impulsodigitalstore.com/cart/42985551102029:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full h-full bg-brand-green text-white py-6 px-6 rounded-2xl shadow-[0_8px_30px_rgba(74,27,109,0.3)] flex flex-col items-center justify-center gap-2 border-2 border-brand-green hover:shadow-[0_10px_40px_rgba(74,27,109,0.5)] transition-all" data-id="element-114">
              <span className="text-xl font-bold flex items-center gap-2" data-id="element-115">
                📦 MEGAPACK EMPRENDE CON DIOS
              </span>
              <div className="flex items-center gap-3" data-id="element-116">
                <span className="line-through text-white/70 text-sm" data-id="element-117">
                  $51.000
                </span>
                <span className="font-black text-2xl" data-id="element-118">→ $19.990 ARS</span>
              </div>
              <span className="mt-2 bg-white text-brand-green px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-119">
                🌸 QUIERO MI MEGAPACK AHORA
              </span>
            </motion.a>
          </div>

          <div className="relative w-full" data-id="element-120">
            <div className="absolute -inset-2 bg-brand-purple/30 blur-2xl rounded-2xl -z-10 pointer-events-none" data-id="element-121"></div>
            <motion.a href="https://www.impulsodigitalstore.com/cart/42985557327949:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full h-full bg-brand-pink text-white py-6 px-6 rounded-2xl shadow-[0_8px_30px_rgba(201,168,76,0.3)] flex flex-col items-center justify-center gap-2 border-4 border-brand-pink hover:shadow-[0_10px_40px_rgba(201,168,76,0.5)] transition-all relative" data-id="element-122">
              <div className="absolute -top-4 bg-white text-brand-pink px-4 py-1 rounded-full text-xs font-black uppercase shadow-md" data-id="element-123">
                MÁS POPULAR
              </div>
              <span className="text-xl font-bold flex items-center gap-2" data-id="element-124">
                👑 MEGAPACK + SISTEMA $100.000 ⭐
              </span>
              <div className="flex items-center gap-3" data-id="element-125">
                <span className="line-through text-white/70 text-sm" data-id="element-126">
                  $69.000
                </span>
                <span className="font-black text-2xl" data-id="element-127">→ $27.990 ARS</span>
              </div>
              <span className="mt-2 bg-white text-brand-pink px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-128">
                👑 QUIERO EL SISTEMA $100.000
              </span>
            </motion.a>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm py-4 sm:py-6 px-2 rounded-2xl border border-white/10 overflow-x-auto" data-id="element-129">
          <div className="flex flex-nowrap justify-center items-center gap-x-3 sm:gap-x-8 text-[10px] sm:text-sm font-bold text-gray-300 whitespace-nowrap" data-id="element-130">
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-131">
              <Lock className="text-brand-green shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-132" />{' '}
              Pago 100% seguro
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-133">
              <Zap className="text-brand-green shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-134" />{' '}
              Acceso en 5 min
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-135">
              <Shield className="text-brand-green shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-136" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-137">
              <CreditCard className="text-brand-green shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-138" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}